/* Form Page to create a Moodboard
 * The word moodshots is used through the app in the urls for moodboards */
import React, { useRef, useState } from "react"

import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Asset from "../../components/Asset"

import Upload from "../../assets/upload.png"
import styles from "../../styles/Scene.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Image from "react-bootstrap/Image"
import Alert from "react-bootstrap/Alert"
// import Info from "./Info"

import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import Asset2 from "../../components/Asset2"
import {
  useCharactersContext,
  useLocationsContext,
  useScenesContext,
} from "../../contexts/Scene_chars_locs"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast"
import InfoCreate from "./InfoCreate"
import { useCurrentUser } from "../../contexts/CurrentUserContext"

const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const MoodboardCreate = ({
  sceneId = "",
  number = "",
  characterRole = "",
  locationPlace = "",
}) => {
  useRedirect()
  const currentUser = useCurrentUser();
  const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser?.project_category_type)
    : null;
  const host = useHostName()
  const [errors, setErrors] = useState({})
  const [showInfo, setShowInfo] = useState(false)
  const [postData, setPostData] = useState({
    scene: sceneId,
    sceneNumber: number,
    title: "",
    content: "",
    character: characterRole,
    location: locationPlace,
    image1: null, // will hold file
    image2: null,
    image3: null,
    image4: null,
    image5: null,
    image1Preview: null, // for URL.createObjectURL()
    image2Preview: null,
    image3Preview: null,
    image4Preview: null,
    image5Preview: null,

  })

  const {
    scene,
    sceneNumber,
    title,
    content,
    character,
    location,
    image1,
    image2,
    image3,
    image4,
    image5,
  } = postData

  const imageInput1 = useRef(null)
  const imageInput2 = useRef(null)
  const imageInput3 = useRef(null)
  const imageInput4 = useRef(null)
  const imageInput5 = useRef(null)

  const history = useHistory()

  const scenes = useScenesContext()
  const characters = useCharactersContext()
  const locations = useLocationsContext()

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const validateImageSize = (file, inputRef) => {
    if (file.size <= MAX_FILE_SIZE_BYTES) {
      return true;
    }

    if (inputRef.current) {
      inputRef.current.value = "";
    }

    toast.error(`Only ${MAX_FILE_SIZE_MB} MB files are allowed.`, {
      duration: 3000,
    });

    return false;
  };

  const handleChangeImage1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput1)) {
        return;
      }
      if (postData.image1Preview) {
        URL.revokeObjectURL(postData.image1Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image1: file,
        image1Preview: previewUrl,
      }));
    }
  };

  const handleChangeImage2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput2)) {
        return;
      }
      if (postData.image2Preview) {
        URL.revokeObjectURL(postData.image2Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image2: file,
        image2Preview: previewUrl,
      }));
    }
  };

  const handleChangeImage3 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput3)) {
        return;
      }
      if (postData.image3Preview) {
        URL.revokeObjectURL(postData.image3Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image3: file,
        image3Preview: previewUrl,
      }));
    }
  };

  const handleChangeImage4 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput4)) {
        return;
      }
      if (postData.image4Preview) {
        URL.revokeObjectURL(postData.image4Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image4: file,
        image4Preview: previewUrl,
      }));
    }
  };

  const handleChangeImage5 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput5)) {
        return;
      }
      if (postData.image5Preview) {
        URL.revokeObjectURL(postData.image5Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image5: file,
        image5Preview: previewUrl,
      }));
    }
  };

  const handleChangeScene = (event) => {
    const scene = event.target.value.split("_")[0]
    const number = event.target.value.split("_")[1]
    setPostData({
      ...postData,
      scene: scene,
      sceneNumber: number,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData()

    formData.append("scene", scene)
    formData.append("number", sceneNumber)
    formData.append("title", title)
    formData.append("content", content)
    formData.append("character", character)
    formData.append("location", location)
    if (imageInput1.current.files[0]) {
      formData.append("image1", imageInput1.current.files[0])
    }
    if (imageInput2.current.files[0]) {
      formData.append("image2", imageInput2.current.files[0])
    }
    if (imageInput3.current.files[0]) {
      formData.append("image3", imageInput3.current.files[0])
    }
    if (imageInput4.current.files[0]) {
      formData.append("image4", imageInput4.current.files[0])
    }
    if (imageInput5.current.files[0]) {
      formData.append("image5", imageInput5.current.files[0])
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const data = await axiosReq.post("/moodshots/", formData)
        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          toast.success(`Moodboard Added`);
          history.goBack()
        }
      } else {
        const data = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/moodshots/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )

        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          toast.success(`Moodboard Added Successfully!`);
          history.goBack()
        }
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const dropfields = (
  <div>
    {projectType !== "Television" ? (
      <Row className="text-center">
      <Col xs={4} className="d-flex justify-content-center" >
      {/* scene */}
      <Form.Group controlId="scenedrop" className={`${styles.Width3}`} >
          <Form.Label className={`${styles.BoldScene} `} >Scene</Form.Label>
          <Form.Control as="select"
              name="scene"
              className={styles.InputChar}
              value={scene.id}
              onChange={handleChangeScene}
              aria-label="scene select">
              <option  value="" ></option>
              {scenes.results.length && (
                  scenes.results.map((scene) => (
                  <option key={scene.id}
                   value={`${scene.id}_${scene.number}`}  >
                     {scene.number} - {scene.location} "{scene.title}"</option>
                  ) )) }
          </Form.Control>
      </Form.Group>
      {errors?.scene?.map((message, idx) => (
           <Alert variant="warning" key={idx}>
           {message}
           </Alert>
       ))}
      </Col>
      <Col xs={4} className="d-flex justify-content-center" >
        {/* location */}
        <Form.Group controlId="locationdrop" className={`${styles.Width3}`}>
            <Form.Label className={`${styles.BoldScene} `} >Location</Form.Label>
            <Form.Control as="select"
                name="location"
                className={styles.InputChar}
                value={location}
                onChange={handleChange}
                aria-label="location select">
                <option  ></option>
                {locations.results.length && (
                    locations.results.map((location) => (
                    <option key={location.id} value={location.name} >{location.name}</option>
                    ) )) }
            </Form.Control>
        </Form.Group>
        {errors?.location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
            {message}
            </Alert>
        ))}
        </Col>
      <Col xs={4} className="d-flex justify-content-center" >
        {/* character */}
        <Form.Group controlId="characterdrop" className={`${styles.Width3}`} >
            <Form.Label className={`${styles.BoldScene} `} >Character</Form.Label>
            <Form.Control as="select"
                name="character"
                className={styles.InputChar}
                value={character}
                onChange={handleChange}
                aria-label="character select">
                <option  ></option>
                {characters.results.length && (
                    characters.results.map((character) => (
                    <option key={character.id} value={character.role} >{character.role}</option>
                    ) )) }
            </Form.Control>
        </Form.Group>
        {errors?.character?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
        </Col>
    </Row>
    ) : (
      <>
      <p className={`${styles.Small} text-center mb-2`}>Create Scene Moodboards from their Scene page</p>
      <Row className="text-center">
      <Col xs={6} className="d-flex justify-content-center" >
        {/* location */}
        <Form.Group controlId="locationdrop" className={`${styles.Width3}`} >
            <Form.Label className={`${styles.BoldScene} `} >Location</Form.Label>
            <Form.Control as="select"
                name="location"
                className={styles.InputChar}
                value={location}
                onChange={handleChange}
                aria-label="location select">
                <option  ></option>
                {locations.results.length && (
                    locations.results.map((location) => (
                    <option key={location.id} value={location.name} >{location.name}</option>
                    ) )) }
            </Form.Control>
        </Form.Group>
        {errors?.location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
            {message}
            </Alert>
        ))}
        </Col>
      <Col xs={6} className="d-flex justify-content-center" >
        {/* character */}
        <Form.Group controlId="characterdrop" className={`${styles.Width3}`} >
            <Form.Label className={`${styles.BoldScene} `} >Character</Form.Label>
            <Form.Control as="select"
                name="character"
                className={styles.InputChar}
                value={character}
                onChange={handleChange}
                aria-label="character select">
                <option  ></option>
                {characters.results.length && (
                    characters.results.map((character) => (
                    <option key={character.id} value={character.role} >{character.role}</option>
                    ) )) }
            </Form.Control>
        </Form.Group>
        {errors?.character?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
        </Col>
    </Row>
    </>
    )}
  </div>
)

const scenePage = (
  <div>
    <Row className="text-center">
      <Col xs={6} className="d-flex justify-content-center">
      <p className={`${styles.BoldScene} pb-2`}>Character</p>
        {/* character */}
        <Form.Group controlId="characterdrop" className={`${styles.Width3}`} >
            <Form.Label className={`d-none`} ></Form.Label>
            <Form.Control as="select"
                name="character"
                className={styles.InputChar}
                value={character}
                onChange={handleChange}
                aria-label="character select">
                <option  ></option>
                {characters.results.length && (
                    characters.results.map((character) => (
                    <option key={character.id} value={character.role} >{character.role}</option>
                    ) )) }
            </Form.Control>
        </Form.Group>
        {errors?.character?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      <Col xs={6} className="d-flex justify-content-center">
        {/* location */}
        <p className={`${styles.BoldScene} pb-2`}>Location</p>
        <Form.Group controlId="locationdrop" className={`${styles.Width3}`} >
            <Form.Label className="d-none" ></Form.Label>
            <Form.Control as="select"
                name="location"
                className={styles.InputChar}
                value={location}
                onChange={handleChange}
                aria-label="location select">
                <option  ></option>
                {locations.results.length && (
                    locations.results.map((location) => (
                    <option key={location.id} value={location.name} >{location.name}</option>
                    ) )) }
            </Form.Control>
        </Form.Group>
        {errors?.location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
            {message}
            </Alert>
        ))}
        </Col>
    </Row>
  </div>
)

const textFields = (
    <div>
    <Row className="text-center">
    <Col md={6} className="d-flex justify-content-center">
    <Form.Group controlId="title" className={`${styles.Width3}`} >
    <Form.Label className={`${styles.BoldScene} `} >Title</Form.Label>
    <Form.Control 
    type="text"
    className={styles.Input}
    name="title"
    value={title}
    onChange={handleChange}
        />
</Form.Group>
{errors?.title?.map((message, idx) => (
  <Alert variant="warning" key={idx}>
    {message}
  </Alert>
))}
    </Col>
    <Col md={6} className="mt-3 mt-md-0 d-flex justify-content-center">
    <Form.Group controlId="content" className={`${styles.Width3}`} >
    <Form.Label className={`${styles.BoldScene} `} >Content</Form.Label>
    <Form.Control 
        className={styles.InputScene}
        type="text"
        name="content"
        as="textarea"
        rows={1}
        value={content}
        onChange={handleChange}
        />
</Form.Group>
{errors?.content?.map((message, idx) => (
  <Alert variant="warning" key={idx}>
    {message}
  </Alert>
))}
    </Col>
    </Row>
    </div>
)

const buttons = (
  <div className="text-center mb-3">    
    <Button
      className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
      onClick={() => history.goBack()}
    >
      Cancel
    </Button>
    <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
      Create
    </Button>
  </div>
);

  return (
    <div>
      <TopBox title="Create Moodboard" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 my-2 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      {!showInfo ? "" : <InfoCreate />}
      <div>
          {sceneId ? (
            <>
            <h5 className={`mt-1 py-1 text-center ${styles.SubTitleMood }`}
            style={{ textTransform: 'uppercase'}}>
            <span className={`${styles.Span100 }`} 
              >Scene {number} - </span>Moodboard</h5>
            <Row>
            <Col xs={1} md={2}></Col>
              <Col xs={10} md={8}>
                  <p style={{ textTransform: 'uppercase'}} className={`text-center pt-2 ${styles.SmallDepts }`}
                  > If needed add Character and or Location, adding the Moodboard 
                    to their pages too</p>
              </Col>
              </Row>
              </>
            ) : characterRole ? (
              <>
              <h5 className={`mt-1 py-1 text-center ${styles.SubTitleMood }`}
              style={{ textTransform: 'uppercase'}}>
              <span className={`${styles.Span100 }`} >
                {characterRole} - </span>Moodboard</h5>
                </>
            ) : locationPlace ? (
              <>
            <h5 className={`mt-1 py-1 text-center ${styles.SubTitleMood }`}
            style={{ textTransform: 'uppercase'}}>
              <span className={`${styles.Span100 }`} >
                {locationPlace} - </span>Moodboard</h5>
              </>
            ) : (
              <h5 className={`mt-1 py-1 text-center ${styles.SubTitleMood }`}>
                CREATE MOODBOARD
              </h5>
            ) }
      </div>
      <Form onSubmit={handleSubmit} className={`pt-3 px-3 ${styles.White }`}>
      <Row >
      <Col className="p-0 px-md-2">
          { sceneId ? (
            <>
            {scenePage}
            </>
          ) : characterRole ? (
            <>
            </>
          ) : locationPlace ? (
            <>
            </>
          ) : (
            <>
            {dropfields}
            </>
          )
          }
      </Col>
      </Row>
      <hr/>
      {textFields}
      <hr/>
      <div>
      {/* image 1 2 */}
      <Row className="d-flex align-items-center">
      <Col xs={12} md={6} className={`pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 1</p>
      <Form.Group className="text-center pt-3">
      {postData.image1Preview ? (
      postData.image1?.type === "application/pdf" ? (
      <>
          <iframe
          src={postData.image1Preview}
          width="40%"
          height="100px"
          style={{ borderRadius: 8, border: "none" }}
          title="PDF Preview"
          />
          <Form.Label
          className={`${btnStyles.Button} ${btnStyles.Blue}`}
          htmlFor="image-upload1"
          >
          Change the file
          </Form.Label>
      </>
      ) : (
      <>
          <figure>
          <Image
              className={appStyles.iframe}
              width="70%"
              height="120px"
              src={postData.image1Preview}
              rounded
          />
          </figure>
          <Form.Label
          className={`${btnStyles.Button} ${btnStyles.Blue}`}
          htmlFor="image-upload1"
          >
          Change the image
          </Form.Label>
      </>
      )
      ) : (
      <Form.Label
      htmlFor="image-upload1"
      >
      <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
      </Form.Label>
      )}
      <Form.Control
      type="file"
      id="image-upload1"
      accept="image/*,application/pdf"
      onChange={handleChangeImage1}
      ref={imageInput1}
      />
      </Form.Group>
      {errors?.image1?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
      {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      <Col xs={12} md={6} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 2</p>
      <Form.Group>
      {postData.image2Preview ? (
          postData.image2?.type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image2Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload2"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image2Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload2"
              >
              Change the image
              </Form.Label>

          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload2"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload2"
          accept="image/*,application/pdf"
          onChange={handleChangeImage2}
          ref={imageInput2}
      />
      </Form.Group>
      {errors?.image2?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      </Row>
      <hr className="d-none d-md-block"/>
      {/* image 3 4 */}
      <Row className="d-flex align-items-center">
      <Col xs={12} md={6} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 3</p>
      <Form.Group>
      {postData.image3Preview ? (
          postData.image3?.type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image3Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload3"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image3Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload3"
              >
              Change the image
              </Form.Label>
          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload3"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload3"
          accept="image/*,application/pdf"
          onChange={handleChangeImage3}
          ref={imageInput3}
      />
      </Form.Group>
      {errors?.image3?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      <Col xs={12} md={6} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 4</p>
      <Form.Group>
      {postData.image4Preview ? (
          postData.image4?.type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image4Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload4"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image4Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload4"
              >
              Change the image
              </Form.Label>
          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload4"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload4"
          accept="image/*,application/pdf"
          onChange={handleChangeImage4}
          ref={imageInput4}
      />
      </Form.Group>
      {errors?.image4?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      </Row>
      <hr className="d-none d-md-block"/>
      {/* image 5 */}
      <Row>
      <Col xs={12} md={{span: 6, offset: 3}} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 5</p>
      <Form.Group>
      {postData.image5Preview ? (
          postData.image5?.type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image5Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload5"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image5Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload5"
              >
              Change the image
              </Form.Label>
          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload5"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload5"
          accept="image/*,application/pdf"
          onChange={handleChangeImage5}
          ref={imageInput5}
      />
      </Form.Group>
      {errors?.image5?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>   
      </Row>
      <hr className="d-none d-md-block"/>
      </div>
        <Row>
          <Col>
            <Container className={`${styles.Container} mt-3`}>
              {buttons}{" "}
            </Container>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default MoodboardCreate
